import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from '../api';

@Injectable()
export class AccountService extends Api {
    private apiUrl: string = this.getApiUrl();
    // private rootUrl: string = this.getRootApi() + this.getApiVersion();

    constructor(private http: HttpClient) {
        super();
    }

    public registerUser(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'signup', params);
    }

    public loginUser(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'auth/login', params);
    }

    public sendPasswordRecoveryKey(params: any): Observable<any> {
        return this.http.post(this.apiUrl + '/reset-password', params);
    }

    public changePassword(params: any): Observable<any> {
        return this.http.post(this.apiUrl + '/newpassword', params);
    }

    public getCurrentUser(): Observable<any> {
        return this.http.get(this.apiUrl + 'user');
    }

    public getUsersList(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'users', { params });
    }

    public updateUserItem(id: number, params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'users/update/' + id, params);
    }

    public importUsersFromFile(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'users/upload', params);
    }

    public updateUserRole(params: any): Observable<any> {
      console.log("params Update User Role", params);
      return this.http.post(this.apiUrl + 'users/role', params);
    }

    // public removeUserRole(params: any): Observable<any> {
    //   console.log("params Remove User Role", params);
    //   return this.http.delete(this.apiUrl + 'users/role', params);
    // }

    public removeUserRole(params: any): Observable<any> {
      console.log("params Remove User Role", params);
      return this.http.delete(this.apiUrl + 'users/role', { body: params });
    }

}
